import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let id = useDataValue({
    context: 'assigned_insurance',
    viewPath: props.viewPath,
    path: 'insurance_subscription.insurance_plan.id',
  })
  return {
    variables: { id },
  }
}
